<div *ngIf="user$ | async as user">
  <div *ngIf="!user?.subscription?.isPremium" class="lg:hidden end-mobile-ad flex items-center justify-start flex-col">
      <!-- adngin-end_mobile-0  -->
      <a routerLink="/remove-ads" class="text-xs text-blue-600 cursor-pointer mb-1" *ngIf="!user.subscription?.isPremium">Remove ads</a>
      <div id="adngin-end_mobile-0"></div>
  </div>
</div>
